// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type Prompt } from "../../api";
import { useGetActivePromptByAufgabeId as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useActivePromptByAufgabeIdQueryKey(
  aufgabeId: string
): QueryKey {
  return ["api", "v1", "aufgaben", aufgabeId, "prompts", "active"];
}

export function useActivePromptByAufgabeId(
  aufgabeId: string,
  options: Omit<UseQueryOptions<Prompt, ApiError>, "queryKey" | "queryFn"> = {}
): Prompt {
  const getter = useGetter();
  return useQuery(
    useActivePromptByAufgabeIdQueryKey(aufgabeId),
    () => getter(aufgabeId),
    options
  ).data!;
}
